import { Box, Typography, Button, Chip, Paper, Divider } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SendIcon from '@mui/icons-material/Send';
import HistoryIcon from '@mui/icons-material/History';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import EditIcon from '@mui/icons-material/Edit';
import { STATUS_MAP } from '../../hooks/useStoreContract';
import StoreContractDialogs from './StoreContractDialogs';

export default function StoreContractPanel({ store, contract }) {
  if (!store?._id) return null;

  const st = STATUS_MAP[store.contractStatus] || STATUS_MAP.none;
  const label = store.name || store.tljNo || store._id;

  return (
    <>
      <GridDivider />
      <Box sx={{ mt: 1 }}>
        <Typography variant="subtitle2" sx={{ color: '#1565C0', fontWeight: 700, mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <DescriptionIcon sx={{ fontSize: 18 }} />
          계약서 (Contracts 연동)
        </Typography>
        <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2, background: '#f8fafc' }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, mb: 1.5 }}>
            <Chip label={st.label} size="small" color={st.color} variant="outlined" sx={{ fontWeight: 600 }} />
            {store.contractSigneeName && (
              <Typography sx={{ fontSize: 11, color: '#64748b' }}>서명: {store.contractSigneeName}</Typography>
            )}
            {store.contractDocUrl && (
              <Button size="small" variant="text" href={store.contractDocUrl} target="_blank"
                startIcon={<OpenInNewIcon sx={{ fontSize: 14 }} />}
                sx={{ fontSize: 11, color: '#551FFF', textTransform: 'none' }}>
                계약서 PDF
              </Button>
            )}
          </Box>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            <Button size="small" variant="contained" startIcon={<SendIcon />}
              onClick={() => contract.openSendDialog(store)}
              sx={{ background: '#551FFF', fontSize: 12, textTransform: 'none' }}>
              계약서 보내기
            </Button>
            <Button size="small" variant="outlined" startIcon={<UploadFileIcon />}
              onClick={() => contract.openUploadDialog(store)}
              sx={{ borderColor: '#22c55e', color: '#16a34a', fontSize: 12, textTransform: 'none' }}>
              계약서 첨부
            </Button>
            <Button size="small" variant="outlined" startIcon={<EditIcon />}
              onClick={() => contract.openEditDialog(store)}
              sx={{ fontSize: 12, textTransform: 'none' }}>
              상태 변경
            </Button>
            <Button size="small" variant="text" startIcon={<HistoryIcon />}
              onClick={() => contract.openLogs(store)}
              sx={{ fontSize: 12, textTransform: 'none', color: '#64748b' }}>
              이력
            </Button>
          </Box>
          <Typography sx={{ fontSize: 10, color: '#94a3b8', mt: 1 }}>
            Admin Settings → Contracts 탭과 동일한 데이터입니다. ({label})
          </Typography>
        </Paper>
      </Box>
      <StoreContractDialogs contract={contract} />
    </>
  );
}

function GridDivider() {
  return <Divider sx={{ my: 2 }} />;
}
